import {useState} from 'react';
import {useMatchesMediaQuery} from '../../../../hooks/useMatchesMediaQuery/useMatchesMediaQuery';
import {ImagePreviewType} from '../../../../types/Image';
import {ProductColorOptionsProps} from '../../ProductColorOptions/ProductColorOptions';

export const useProductColorOptionsPreview = ({
  colorOptions,
  setPreviewImage,
}: {
  colorOptions: ProductColorOptionsProps['options'];
  setPreviewImage?: (previewImage?: ImagePreviewType) => void;
}) => {
  const supportsHover = useMatchesMediaQuery('(pointer: fine)');

  const [previewUrl, setPreviewUrl] = useState<string>();
  const [temporaryName, setTemporaryName] = useState<string | null>(null);
  // temporaryName is set when user hovers to the product thumbnail
  // and cleared when user leaves the mouse from the product thumbnail
  // so we use it to temporarily change the ColorLabel text
  const activeName =
    temporaryName || colorOptions.find(color => color.isActive)?.name;

  const activeColorIndex = colorOptions.findIndex(color => color.isActive);

  const handleColorOptionMouseLeave = () => {
    if (!supportsHover) {
      return;
    }

    setPreviewImage?.();
    // Clear the temporary name on mouse leave
    setTemporaryName(null);
    setPreviewUrl(undefined);
  };

  const handleColorOptionMouseEnter =
    ({
      isActive,
      image,
      name,
    }: {
      isActive: boolean;
      image: ImagePreviewType;
      name: string;
    }) =>
    () => {
      if (isActive && !!previewUrl) {
        handleColorOptionMouseLeave();
      }

      if (isActive || !supportsHover || previewUrl === image.url) {
        return;
      }

      setPreviewImage?.(image);
      setTemporaryName(name);
      setPreviewUrl(image.url);
    };

  return {
    previewUrl,
    activeName,
    handleColorOptionMouseEnter,
    handleColorOptionMouseLeave,
    activeColorIndex,
  };
};
